import React from 'react';
import {
    TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Collapse, IconButton
} from '@material-ui/core';
import Dimmer from '+/Dimmer';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { useGroupings } from '~/groupings';
import GroupingsTable from './GroupingsTable';

const UnitTypes = () => {

    const { data: properties, isLoading } = useGroupings();
    const [rowExpanded, setRowExpanded] = React.useState(-1);

    const handleExpandRow = i => {
        setRowExpanded(currentIndex => (i === currentIndex ? -1 : i));
    };

    if (isLoading) {
        return <Dimmer message='Loading...' />;
    }

    return (

        <TableContainer component={Paper}>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '80px' }}/>
                        <TableCell>
                                Property
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {properties.map((property, i) => (
                        <React.Fragment key={i}>
                            <TableRow key={property.name}>
                                <TableCell>
                                    <IconButton size='small' onClick={() => handleExpandRow(i)}>
                                        { rowExpanded === i ? <ArrowUpward /> : <ArrowDownward /> }
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    {property.name}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell
                                    style={{
                                        paddingBottom: 0,
                                        paddingTop: 0
                                    }}
                                    colSpan={5}
                                >
                                    <Collapse in={rowExpanded === i} timeout='auto' unmountOnExit>
                                        <GroupingsTable data={property} />
                                    </Collapse>
                                </TableCell>
                            </TableRow>

                        </React.Fragment>
                    ))}
                </TableBody>

            </Table>
        </TableContainer>

    );
};

export default UnitTypes;
